export default "__VITE_ASSET__Ccz2cDhc__"